module.exports = __webpack_public_path__ + "img/linea1-4.ec87b03d.png";